import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { QueueScenarioAPI } from "../../../constants/API";
import { commonHeaders } from "../../../constants/HeadersAPI";
import {
  QueueScenarioSettingsDto,
  TicketNumberMode,
} from "./useGetQueueScenarioSettings";

export type QueueScenarioSettingsRequest = {
  noShowTimeoutSeconds?: number | null;
  autoDistributeEnabled?: boolean;
  autoDistributeDelaySeconds?: number;
  lcdRotationIntervalSeconds?: number;
  ticketNumberMode?: TicketNumberMode;
  regularTicketPrefix?: string;
  benefitTicketPrefix?: string;
  ticketNumberDigits?: number;
  ticketNumberPadZeros?: boolean;
};

export const usePutQueueScenarioSettings = (branchQueueId: number | null) => {
  const queryClient = useQueryClient();
  return useMutation(
    (payload: QueueScenarioSettingsRequest) =>
      axios.put<QueueScenarioSettingsDto>(
        QueueScenarioAPI.updateSettings(branchQueueId!),
        payload,
        commonHeaders(),
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["queueScenarioSettings", branchQueueId]);
      },
    },
  );
};
